import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import useTranslation from '../hooks/useTranslation';
import './VideoSection.css';

const VideoSection = () => {
  const { t, isRTL } = useTranslation();
  const [isPlaying, setIsPlaying] = useState(false);

  // Example Orkina Media YouTube Video ID (Placeholder)
  const videoId = "jRmsatr9p7g";

  return (
    <section className="video-section">
      <div className="container">
        <motion.div
          className="section-heading"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="services__label">{isRTL ? 'معرض الإنتاج' : 'Production Showcase'}</span>
          <h2>{isRTL ? 'شاهد أعمالنا' : 'Watch Our Work'}</h2>
          <p>
            {isRTL
              ? 'نقدم لكم لمحة عن جودة وكفاءة إنتاجنا الإعلامي الإبداعي'
              : 'Take a glimpse into the quality and creativity of our media production work.'}
          </p>
        </motion.div>

        <div className="video-container">
          <AnimatePresence mode="wait">
            {!isPlaying ? (
              <motion.div
                key="thumbnail"
                className="video-thumbnail"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 1.05 }}
                onClick={() => setIsPlaying(true)}
              >
                <img
                  src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
                  alt="Video Showcase Thumbnail"
                  className="video-thumb-img"
                />
                <div className="video-overlay">
                  <motion.button
                    className="play-button"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </motion.button>
                </div>
              </motion.div>
            ) : (
              <motion.div
                key="iframe"
                className="video-iframe-wrap"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
              >
                <iframe
                  width="100%"
                  height="100%"
                  src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                  title="Orkina Production Showcase"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
